<!-- Body -->
<div class="horizontal-content">

    <!-- Left Content -->
    <ng-content select="#left"></ng-content>

    <!-- Tab Content -->
    <div class="flex-content"
        style="display: flex">

        <!-- Core File -->
        <span style="font-style: italic"
            translate>Select the area around which this query will be focused.</span>
        <tyl-form-field label="Area">
            <mat-select id="wizardCoreFileSelector"
                name="wizardCoreFileSelector"
                #coreFileField
                [(ngModel)]="selectedCoreFileId"
                (ngModelChange)="coreFileChange($event)"
                required>
                <mat-option *ngFor="let coreFile of coreFiles"
                    [value]="coreFile.ID">
                    {{coreFile.Name}}
                </mat-option>
            </mat-select>
        </tyl-form-field>

        <!-- Quick Starts -->
        <ng-container *ngIf="selectedCoreFileId > 0">
            <span style="font-weight: bold"
                translate>Quick Starts</span>
            <span style="font-style: italic"
                translate>Preselected fields and filters</span>
            <tyl-radio-group id="quickStartRadios"
                arrange="vertical"
                [(selected)]="selectedQuickStartId"
                (selectedChange)="quickStartChange($event)"
                [values]="quickStartValues"
                [labels]="quickStartLabels"
                [ids]="quickStartIds"></tyl-radio-group>
        </ng-container>

        <!-- Filters -->
        <div style="margin-top: 10px">
            <tyl-form-field *ngFor="let filter of coreFileFilters"
                [label]="filter.Name">
                <mat-select [ngModel]="selectedCoreFileFilterOptionId"
                    (ngModelChange)="filterOptionChange($event)">
                    <mat-option *ngFor="let filterOption of filter.FilterOptions"
                        [value]="filterOption.ID">
                        {{filterOption.Name}}
                    </mat-option>
                </mat-select>
            </tyl-form-field>
        </div>
    </div>

    <!-- Left Content -->
    <ng-content select="#right"></ng-content>
</div>



<!-- Footer -->
<div class="flex-footer">

    <!-- Left -->
    <div class="flex-footer-left">
        <ng-content select="#leftFooter"></ng-content>
    </div>

    <!-- Right -->
    <div class="flex-footer-right">
        <error-prompt [errorList]="simpleValidationErrors"></error-prompt>
        <ng-content select="#rightFooter"></ng-content>
    </div>
</div>